import {
  Button,
  Checkbox,
  Form,
  type FormProps,
  Input,
  Typography,
} from 'antd';
import { AxiosError } from 'axios';

import { FormItem } from '@/components';
import { API_STATUS_CODE } from '@/constants/api.constants';
import { ROUTES_PATH } from '@/constants/routes.constants';

const { Text } = Typography;

interface LoginFormProps extends FormProps {
  error: unknown;
  isPending: boolean;
}

function openSendEmailScreen() {
  window.open(
    `${import.meta.env.VITE_APP_URL}${ROUTES_PATH.passwordResetSendEmail}`,
    '_blank',
  );
}

export function LoginForm({
  error,
  isPending,
  ...rest
}: Readonly<LoginFormProps>) {
  return (
    <Form layout="vertical" {...rest}>
      <FormItem
        label="メールアドレス"
        name="username"
        rules={[{ required: true, whitespace: true }]}
      >
        <Input />
      </FormItem>
      <FormItem
        label="パスワード"
        name="password"
        className="mb-16"
        rules={[{ required: true, whitespace: true }]}
      >
        <Input.Password />
      </FormItem>
      <FormItem className="mb-32">
        <FormItem
          className="mb-0"
          name="is_remember_me"
          valuePropName="checked"
        >
          <Checkbox>ログイン情報を保存する</Checkbox>
        </FormItem>
        {!!error && (
          <Text type="danger" className="text-md white-space-pre-wrap">
            {error instanceof AxiosError &&
            error.response?.status === API_STATUS_CODE.forbidden
              ? 'サービスの契約が切れている為、ログインできません。\n事務局までお問い合わせください。'
              : '認証に失敗しました。入力内容を再度確認してください。'}
          </Text>
        )}
      </FormItem>
      <FormItem className="text-center">
        <Button block type="primary" htmlType="submit" loading={isPending}>
          ログイン
        </Button>
        <Button type="text" className="mt-24" onClick={openSendEmailScreen}>
          <Text className="text-md" underline>
            パスワードをお忘れの場合
          </Text>
        </Button>
      </FormItem>
    </Form>
  );
}
